module.exports = __webpack_public_path__ + "media/applicants/cnn-d51bfd67.png";